enum DropsPaths {
  CreateSubmission = 'drops/dropId/submissions/',
}

export default DropsPaths;
